import { FeedbackResponseDto } from '../../../../../types/FeedbackResponseDto';

export const getIsSelfAssessment = (response: FeedbackResponseDto): boolean => {
    return response.reviewees.some(reviewee => reviewee.id === response.reviewer.id);
};
